import { TFunction } from 'i18next'

import { NeighbourhoodPerk } from '@/api/neighbourhood-perks'
import { Avatar } from '@/components/ui/avatar'
import { Badge } from '@/components/ui/badge'
import { TableColumn } from '@/components/ui/table'
import { Tooltip } from '@/components/ui/tooltip'
import { Typography } from '@/components/ui/typography'
import { getAssetLink } from '@/helpers/get-asset-link'

import { NameCell } from '../../../../shared/person-name-cell/person-name-cell.styled'
import { PERK_IMAGES_PATH } from './perks.constants'
import { PerkSortKey } from './perks.sort-keys'
import * as S from './perks.styled'

export const getPerkColumns = (
  t: TFunction<['organisation']>,
): TableColumn<NeighbourhoodPerk>[] => [
  {
    id: 'perk',
    render: (perk) => (
      <NameCell>
        <Avatar
          shape="square"
          size="small"
          src={getAssetLink({ file: perk.logo ?? undefined, path: PERK_IMAGES_PATH })}
        />
        <Typography color="black800" size="text-small" weight="medium" breakLines={1}>
          {perk.name}
        </Typography>
      </NameCell>
    ),
    sortKey: PerkSortKey.name,
    title: t('organisation:places.perks.columns.perk'),
    width: '24rem',
  },
  {
    id: 'description',
    render: (perk) => (
      <Tooltip
        fullWidth
        disabled={!perk.description}
        trigger={
          <Typography color="black500" size="text-small" weight="medium" breakLines={2}>
            {perk.description}
          </Typography>
        }
      >
        {perk.description}
      </Tooltip>
    ),
    sortKey: PerkSortKey.description,
    title: t('organisation:places.perks.columns.description'),
    width: '24rem',
  },
  {
    id: 'category',
    render: (perk) => (
      <Typography color="black500" size="text-small" weight="medium" breakLines={1}>
        {perk.category}
      </Typography>
    ),
    sortKey: PerkSortKey.category,
    title: t('organisation:places.perks.columns.category'),
    width: '17rem',
  },
  {
    id: 'type',
    render: (perk) => (
      <Typography color="black500" size="text-small" weight="medium" breakLines={1}>
        {perk.url
          ? t('organisation:places.perks.types.website')
          : t('organisation:places.perks.types.promoCode')}
      </Typography>
    ),
    sortKey: PerkSortKey.type,
    title: t('organisation:places.perks.columns.type'),
    width: '11rem',
  },
  {
    id: 'discount',
    render: (perk) => (
      <Badge color="blue" size="small" variant="light">
        {perk.tag}
      </Badge>
    ),
    sortKey: PerkSortKey.discount,
    title: t('organisation:places.perks.columns.discount'),
    width: '8rem',
  },
  {
    id: 'offer',
    render: (perk) =>
      perk.url ? (
        <S.OfferLink href={perk.url} rel="noopener noreferrer" target="_blank">
          <Typography color="blue500" size="text-small" weight="medium" breakLines={1}>
            {perk.url}
          </Typography>
        </S.OfferLink>
      ) : (
        <Typography color="black500" size="text-small" weight="medium" breakLines={1}>
          {perk.link ?? ''}
        </Typography>
      ),
    sortKey: PerkSortKey.offer,
    title: t('organisation:places.perks.columns.offer'),
    width: '22rem',
  },
]
